// src/constants/themeDefaults.ts

export interface ThemeColors {
  background: string;
  heart: string;
  text: string;
  accent: string;
  overlay: string;
  box: string;
  accentLine: string;
  inviteBoxBackground: string;
  sectionsBackground: string;
}

export const themeDefaults: Record<string, ThemeColors> = {
  // === ELEGANT HERO (inchangé - préservé tel quel) ===
  ElegantHero: {
    background: "#002c3c",
    heart: "#ff4d6d",
    text: "#c49f59",
    accent: "#ff99b3",
    overlay: "rgba(11,12,42,0.65)",
    box: "rgba(255,182,193,0.15)",
    accentLine: "#c49f59",
    inviteBoxBackground: "rgba(255,182,193,0.15)",
    sectionsBackground: "rgba(255,255,255,0.1)"
  },

  // === NOIR DOUX & OR MAT ===
  ClassiqueHero: {
    background: "#121212",
    heart: "#c2a46d",
    text: "#e8e6e3",
    accent: "#d6c6a8",
    overlay: "rgba(0,0,0,0.65)",
    box: "rgba(255,255,255,0.04)",
    accentLine: "#c2a46d",
    inviteBoxBackground: "rgba(255,255,255,0.06)",
    sectionsBackground: "rgba(0,0,0,0.35)"
  },

  // === CHAMPAGNE CLAIR - MODERNE (overlay renforcé) ===
  ModerneHero: {
    background: "#f5f1ea",
    heart: "#bfa37a",
    text: "#3a3a3a",
    accent: "#7a6a58",
    overlay: "rgba(0,0,0,0.35)", // Augmenté de 0.15 à 0.35 pour meilleure visibilité
    box: "rgba(255,255,255,0.7)",
    accentLine: "#bfa37a",
    inviteBoxBackground: "rgba(255,255,255,0.85)",
    sectionsBackground: "rgba(255,255,255,0.6)"
  },

  // === VERT FORÊT - VERSION MODERNE (adouci) ===
  VertForet: {
    background: "#1f2a38",
    heart: "#c7cbd6",
    text: "#e6e9ef",
    accent: "#aab2c0",
    overlay: "rgba(0,0,0,0.6)",
    box: "rgba(255,255,255,0.05)",
    accentLine: "#c7cbd6",
    inviteBoxBackground: "rgba(255,255,255,0.08)",
    sectionsBackground: "rgba(0,0,0,0.3)"
  },

  // === BLEU NUIT - VERSION MODERNE (adouci) ===
  BleuNuit: {
    background: "#0f1c2b",
    heart: "#d2c2a8",
    text: "#e9e6e1",
    accent: "#b8b2a6",
    overlay: "rgba(0,0,0,0.7)",
    box: "rgba(255,255,255,0.04)",
    accentLine: "#d2c2a8",
    inviteBoxBackground: "rgba(255,255,255,0.07)",
    sectionsBackground: "rgba(0,0,0,0.4)"
  },

  // === MAUVE POUDRÉ DOUX - ÉLÉGANT ===
  MauveSaphir: {
    background: "#2b2430",
    heart: "#c8b6c8",
    text: "#e7e3ea",
    accent: "#b8a9c9",
    overlay: "rgba(0,0,0,0.6)",
    box: "rgba(255,255,255,0.05)",
    accentLine: "#c8b6c8",
    inviteBoxBackground: "rgba(255,255,255,0.08)",
    sectionsBackground: "rgba(0,0,0,0.3)"
  },

  // === BORDEAUX ÉLÉGANT ===
  BordeauxPeche: {
    background: "#3a1f24",
    heart: "#d4b8a3",
    text: "#f1eae4",
    accent: "#cbb2a0",
    overlay: "rgba(0,0,0,0.6)",
    box: "rgba(255,255,255,0.05)",
    accentLine: "#d4b8a3",
    inviteBoxBackground: "rgba(255,255,255,0.08)",
    sectionsBackground: "rgba(0,0,0,0.35)"
  },

  // === ROSE PÂLE CALME - ÉLÉGANT ===
  RoseBordeaux: {
    background: "#3c2529",
    heart: "#d8b4b4",
    text: "#f2ecec",
    accent: "#c9a7a7",
    overlay: "rgba(0,0,0,0.55)",
    box: "rgba(255,255,255,0.05)",
    accentLine: "#d8b4b4",
    inviteBoxBackground: "rgba(255,255,255,0.08)",
    sectionsBackground: "rgba(0,0,0,0.3)"
  },

  // === BEIGE & BRUN DOUX - CLASSIQUE ===
  BeigeMarron: {
    background: "#3b312c",
    heart: "#cbb7a1",
    text: "#f0ebe5",
    accent: "#a8957d",
    overlay: "rgba(0,0,0,0.6)",
    box: "rgba(255,255,255,0.04)",
    accentLine: "#cbb7a1",
    inviteBoxBackground: "rgba(255,255,255,0.07)",
    sectionsBackground: "rgba(0,0,0,0.35)"
  },

  // === ROUGE PROFOND DOUX - CLASSIQUE ===
  CarminRose: {
    background: "#4a1f28",
    heart: "#d6b0a0",
    text: "#f3ece8",
    accent: "#c4a29a",
    overlay: "rgba(0,0,0,0.6)",
    box: "rgba(255,255,255,0.05)",
    accentLine: "#d6b0a0",
    inviteBoxBackground: "rgba(255,255,255,0.08)",
    sectionsBackground: "rgba(0,0,0,0.35)"
  },

  // === TEMPLE ARDOISE (gris bleuté) ===
  TempleHero: {
    background: "#2a3a4a",
    heart: "#c9b8a8",
    text: "#f0e8e0",
    accent: "#3a4a5a",
    overlay: "rgba(0,0,0,0.3)",
    box: "#3a4a5a",
    accentLine: "#c9b8a8",
    inviteBoxBackground: "#3a4a5a",
    sectionsBackground: "#2a3a4a"
  },

  // === TEMPLE GRAPHITE (gris anthracite) ===
  TempleNoir: {
    background: "#2a2a2a",
    heart: "#b8a898",
    text: "#f0e8e0",
    accent: "#3a3a3a",
    overlay: "rgba(0,0,0,0.3)",
    box: "#3a3a3a",
    accentLine: "#b8a898",
    inviteBoxBackground: "#3a3a3a",
    sectionsBackground: "#2a2a2a"
  },

  // === TEMPLE PLOMB (gris moyen) ===
  TempleSable: {
    background: "#3a3a3a",
    heart: "#d4b8a8",
    text: "#f0e8e0",
    accent: "#4a4a4a",
    overlay: "rgba(0,0,0,0.2)",
    box: "#4a4a4a",
    accentLine: "#d4b8a8",
    inviteBoxBackground: "#4a4a4a",
    sectionsBackground: "#3a3a3a"
  }
};

export const getDefaultTheme = (template: string): ThemeColors => {
  return themeDefaults[template] || themeDefaults.ClassiqueHero;
};

export const themeList = Object.keys(themeDefaults);